import { Component } from "react";
import { gql } from "@apollo/client";
import { graphql, withApollo } from "@apollo/client/react/hoc";
import loadExternal from "load-external";
import { connect } from "react-redux";
import { Icon, Loader } from "semantic-ui-react";

const JAVASCRIPT_URL =
  "https://s3.amazonaws.com/cdn.hellosign.com/public/js/hellosign-embedded.LATEST.min.js";

const SignatureUrlQuery = gql`
  query HelloSignEmbeddedSignatureUrl($signature_id: String!) {
    hellosign_embedded_signature_url(signature_id: $signature_id)
  }
`;

class HelloSignEmbedded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jsDidLoad: false,
      fetchingSignatureUrl: false,
      completedSignatureId: props.signature_id,
    };
  }

  componentDidMount() {
    loadExternal(JAVASCRIPT_URL, this.init.bind(this));
  }

  onMessage(eventData) {
    const { onComplete } = this.props;
    console.log("GOT EVENT DATA: ", eventData);

    if (eventData.event === HelloSign.EVENT_SIGNED) {
      this.setState({ completedSignatureId: eventData.signature_id });
      if (onComplete) {
        onComplete(
          eventData.signature_id,
          this.props.data.hellosign_embedded_signature_request
            .signature_request_id
        );
      }
    } else {
      console.log("Don't know how to handle event data: ", eventData);
    }
  }

  canOpenForSignature() {
    const { data } = this.props;

    return (
      !data.loading &&
      this.state.jsDidLoad &&
      !this.state.completedSignatureId &&
      !this.state.fetchingSignatureUrl
    );
  }

  init() {
    const { client_id } = this.props.constants.hellosign;

    HelloSign.init(client_id);
    this.setState({ jsDidLoad: true });
  }

  open = () => {
    if (!this.canOpenForSignature()) {
      return null;
    }

    const {
      constants: { rails_env },
    } = this.props;

    this.setState({ fetchingSignatureUrl: true });

    this.props.client
      .query({
        query: SignatureUrlQuery,
        variables: {
          signature_id:
            this.props.data.hellosign_embedded_signature_request.signature_id,
        },
        fetchPolicy: "network-only", // can't reuse the signature url. and we need to call HelloSign.open every time.
      })
      .then((result) => {
        HelloSign.open({
          url: result.data.hellosign_embedded_signature_url,
          allowCancel: true,
          messageListener: this.onMessage.bind(this),
          skipDomainVerification: rails_env !== "production",
        });
      })
      .catch((err) => {
        console.log("catch", err);
      })
      .finally(() => {
        this.setState({ fetchingSignatureUrl: false });
      });
  };

  render() {
    let AsComponent = this.props.as;
    if (!AsComponent) {
      AsComponent = "a";
    }

    if (this.state.completedSignatureId) {
      return (
        <AsComponent>
          <Icon color="green" name="check circle" size="large" />
        </AsComponent>
      );
    }

    if (this.state.fetchingSignatureUrl) {
      return <Loader active inline size="tiny" style={{ float: "right" }} />;
    }

    return (
      <AsComponent
        href="#"
        onClick={this.open}
        disabled={!this.canOpenForSignature()}
      >
        Review & Sign
        <Icon name="chevron right" size="small" />
      </AsComponent>
    );
  }
}

const SignatureRequestQuery = gql`
  query HelloSignEmbeddedSignatureRequest(
    $email: String!
    $name: String!
    $template_id: String!
    $role: String!
  ) {
    hellosign_embedded_signature_request(
      email: $email
      name: $name
      template_id: $template_id
      role: $role
    ) {
      signature_id
      signature_request_id
    }
  }
`;

const Query = graphql(SignatureRequestQuery);

const mapStateToProps = ({ constants }) => ({ constants });

export default connect(mapStateToProps)(withApollo(Query(HelloSignEmbedded)));
